<template>
  <div class="main">
    <div id="wdr-component" v-loading="loading" style="margin-left:0px;"></div>
    <div id="highchartsContainer"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lan from "../../store/ch.js";
import Permissions from "../../store/permissions.js";
var daterange = "-";
export default {
  data() {
    return {
      pivot: null,
      loading: true,
    };
  },
  methods: {
    ...mapActions("commonsearch", ["getPivotTable"]),
    customizeToolbar(toolbar) {
       var t = this.$route.query.datatype;
      var tabs = toolbar.getTabs();
     
      var self = this;
      var routeName = "";
      var t = self.$route.query.datatype;
 
      toolbar.getTabs = function () {
            tabs[2].handler = function () {
               self.$router.go(-1);
            };
        // tabs[8].handler = function() {
        //     // alert('保存方案');
        // };
        // tabs[9].handler = function() {
        //     // alert('车型筛选');
        // };
        /*     tabs[3].handler = function () {
          // alert('没有图表');
        };
        if (t == "model") {
          if (!Permissions.Client_ViewSales_Model_Down()) {
            tabs[2].handler = function () {
              alert("没有下载权限");
            };
          }
        } else if (t == "line") {
          if (!Permissions.Client_ViewSales_Line_Down()) {
            tabs[2].handler = function () {
              alert("没有下载权限");
            };
          }
        } else {
          if (!Permissions.Client_ViewSales_Eq_Down()) {
            tabs[2].handler = function () {
              alert("没有下载权限");
            };
          }
        }  */

        // tabs[10].title = "返回";
        // tabs[10].handler = function() {

        //     if(t == "model"){

        //         routeName = 'saleanalysis';
        //     }else if(t=="line")
        //     {
        //          routeName = 'linesaleanalysis';
        //     }
        //      self.$router.push({
        //             name: routeName,
        //        });
        // };
        // // alert(this.daterange);
        // tabs[11].title = daterange;
        return tabs;
      };
    },
    setWebDataRocks(json) {
       self = this;
      var t = this.$route.query.datatype;
      var slice = {};
      if (t == "model") {
        slice = {
          "rows":[   { uniqueName: "子车型" }, { uniqueName: "日期" },{ uniqueName: "销量" }],
           "measures":[{ uniqueName: "sales" }],
        };
      } else if (t == "line") {
        slice = {
          columns: [
            { uniqueName: "车款" },
            { uniqueName: "子车型" },
            { uniqueName: "MSRP" },
            { uniqueName: "tp" },
            { uniqueName: "mix" },
            { uniqueName: "子车型销量" },
            { uniqueName: "车款销量" },
            { uniqueName: "日期" },
            { uniqueName: "状态" },
          ],
           "measures":[{ uniqueName: "子车型销量" }, { uniqueName: "车款销量" }],
        };
      } else if(t=="gain"){
          slice = {
          "rows":[   { uniqueName: "子车型" }, { uniqueName: "月份" } ],
           "measures":[{ uniqueName: "销量" }],
        };

      }
  
      this.pivot = new xPivot({
        container: "#wdr-component",
        global: {
          localization: lan,
        },
        height: "95%",
        width: "96%",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        report: {
          dataSource: {
            data: json,
          },
         // slice: slice,
          options: {
            configuratorActive: false,
            xpandAll: true,
            grid: {
              type: "flat", // "classic",
              showTotals: "true",
              showGrandTotals: "false",
              showHierarchies: true,
            },
          },
          expands: {
            expandAll: true,
          },
        },

        // reportcomplete: function (at) {
         //  alert("reportcomplete");
          // self.pivot.off("reportcomplete");
        //  self.createChart();
        // },
      });
      //pivot.on('reportchange', () => { pivot.getData({}, function (data) { console.log('D2 ', data) }) });
      /* 
                  //获取报告
                   var report = pivot.getReport();
                    console.log(report);
                //获取筛选的表
                    var result;
                    pivot.getData({}, function (data) { result = data; });
                */
    },
    createChart() {
      this.pivot.highcharts.getData(
        {
          type: "areaspline",
        },
        function (data) {
          this.pivot.highcharts.chart("highchartsContainer", data);
        },
        function (data) {
          this.pivot.highcharts.chart("highchartsContainer", data);
        }
      );
    },
  },
  mounted() {
    var key = this.$route.query.pivotTableKey;
    var daterange = this.$route.query.daterange;
    var source = this.$route.query.source;
    var datatype = this.$route.query.datatype;
    var ids = this.$route.query.ids;
    daterange = this.$route.query.daterange;
    this.getPivotTable({
      key: key,
      cb: this.setWebDataRocks,
      daterange: daterange,
      datatype: datatype,
      source: source,
      ids: ids,
    });
  },
  computed: {
    ...mapGetters("commonsearch", ["selectionResult", "pivotTableUri"]),
  },
};
</script>

<style>
#wdr-component {
  padding-bottom: 30px;
  min-height: 800px;
  margin-left: 65px;
  margin-right: 1px;
}
#wdr-toolbar-wrapper div.wdr-popup.wdr-popup-chart {
  width: 90%;
  height: 90%;
}
#wdr-toolbar-wrapper #wdr-toolbar li#wdr-tab-times {
  width: 250px;
}
#wdr-toolbar-wrapper #wdr-toolbar li#wdr-tab-times span {
  font-weight: bold;
}
#wdr-toolbar-wrapper #wdr-toolbar{
  background-color:#f3f6fb !important;
}
</style>
